module.exports = __webpack_public_path__ + "assets/img/report-code.de4994c9.png";